import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import PulseOfTheContinent from "./sections/PulseOfTheContinent";
import Portfolio from "./sections/Portfolio";
import TheRoadToClosing from "./sections/TheRoadToClosing";
import TailoredForEveryDepartment from "./sections/TailoredForEveryDepartment";
import TailoredFinancialSuites from "./sections/TailoredFinancialSuites";
import TheBriefingRoom from "./sections/TheBriefingRoom";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <PulseOfTheContinent />
      <Portfolio />
      <TheRoadToClosing />
      <TailoredForEveryDepartment />
      <TailoredFinancialSuites />
      <TheBriefingRoom />
      <Footer />
    </div>;
}